module.exports = {
        srcSet: __webpack_public_path__ + "amenities_mio_shop_CH-200-f90cbc2a24f85d40.digested.png"+" 200w",
        images: [{path: __webpack_public_path__ + "amenities_mio_shop_CH-200-f90cbc2a24f85d40.digested.png",width: 200,height: 200}],
        src: __webpack_public_path__ + "amenities_mio_shop_CH-200-f90cbc2a24f85d40.digested.png",
        toString: function(){return __webpack_public_path__ + "amenities_mio_shop_CH-200-f90cbc2a24f85d40.digested.png"},
        
        width: 200,
        height: 200
      }